export default __webpack_public_path__ + "static/media/location-unavailable.33b5b65e.png";